'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./ImageFileInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Styles


var ImageFileInput = function (_React$Component) {
    _inherits(ImageFileInput, _React$Component);

    function ImageFileInput(props) {
        _classCallCheck(this, ImageFileInput);

        var _this = _possibleConstructorReturn(this, (ImageFileInput.__proto__ || Object.getPrototypeOf(ImageFileInput)).call(this, props));

        _this.handleFileSelection = _this.handleFileSelection.bind(_this);
        return _this;
    }

    /**
     * Handles the selection of a file to upload.
     * If the file is not provided or is not an image then it does nothing, otherwise it delegates the uploading
     * to a passed in property.
     */


    _createClass(ImageFileInput, [{
        key: 'handleFileSelection',
        value: function handleFileSelection(event) {
            var fileInput = this.refs.fileInput;
            var uploadImage = this.props.uploadImage;

            // Don't do anything when no files are uploaded

            if (!fileInput.files.length || !uploadImage) return;

            var file = fileInput.files[0];

            uploadImage(file);
        }
    }, {
        key: 'render',
        value: function render() {
            var id = this.props.id;

            return _react2.default.createElement('input', { className: 'ImageFileInput', type: 'file', accept: 'image/*', name: 'file-input-' + id,
                id: 'file-input-' + id, ref: 'fileInput', onChange: this.handleFileSelection });
        }
    }]);

    return ImageFileInput;
}(_react2.default.Component);

ImageFileInput.propTypes = {
    id: _propTypes2.default.string.isRequired,
    uploadImage: _propTypes2.default.func
};

exports.default = ImageFileInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/tools/images/ImageFileInput.js
// module id = 444
// module chunks = 0